import { toast } from "react-toastify";
import SecureLS from "secure-ls";
import { sortTypes } from "../assets/constants/constant";

var ls = new SecureLS();

// set data in Local storage in encrypt mode
export function setToLocalStorage(key, data) {
  ls.set(key, data);
}

// get data from local storage
export function getFromLocalStorage(key) {
  let dataFromStorage = ls.get(key);
  return dataFromStorage;
}

// remove data from local storage
export function removeFromLocalStorage(key) {
  ls.remove(key);
}

// remove all keys from storage
export function removeAllFromLocalStorage() {
  ls.removeAll();
}
export const discountedPrice = (data) => {
  let amount = 0;
  if (data?.discountType === 1) {
    amount = data?.price - (data?.price * data?.discountValue) / 100;
    if (amount.toString().includes(".")) {
      amount = amount?.toFixed(2);
    }
  } else if (data?.discountType === 2) {
    amount = data?.price - data?.discountValue;
  } else {
    amount = data?.price;
  }
  return amount;
};
export const sortingList = (sortType, data) => {
  const tempProduct = data;

  let finalList = [];

  if (sortType === sortTypes?.priceLowest) {
    finalList = tempProduct?.sort(
      (a, b) => discountedPrice(a) - discountedPrice(b)
    );
  }
  if (sortType === sortTypes?.priceHighest) {
    finalList = tempProduct?.sort(
      (a, b) => discountedPrice(b) - discountedPrice(a)
    );
  }
  if (sortType === sortTypes?.sortAscending) {
    finalList = tempProduct?.sort((a, b) => a.name.localeCompare(b.name));
  }

  if (sortType === sortTypes?.sortDecending) {
    finalList = tempProduct?.sort((a, b) => b.name.localeCompare(a.name));
  }
  return finalList;
};

export const isAuth = () => {
  let user = getFromLocalStorage("token");
  if (user) {
    return true;
  }
  return false;
};

export const couponType = { Percentage: 1, Fixed: 2 };

export const trackingNumberCopy = (number) => {
  try {
    toast.success("Copied to clipboard!");
  } catch (error) {
    toast.error("Unable to copy text to clipboard!");
  }
};

export const totalAmout = (
  subtotal = 0,
  rewards = 0,
  shippingCharge = 0,
  discount = 0
) => {
  let amount = 0;
  let totalDiscount = rewards + discount;
  let total = subtotal + shippingCharge;
  amount = total - totalDiscount;
  return amount;
};
